import type { RecommendationAddInterventionButtonProps } from "./recommendation-add-intervention-button.type";

import { useGetObservationRiskMatrix } from "@/entities/observation";
import InterventionAddButton from "@/modules/intervention/intervention-add-button";

const RecommendationAddInterventionButton = ({
  interventionAsset,
  observation,
  loading = false,
  ...buttonprops
}: RecommendationAddInterventionButtonProps) => {
  const recommendation = observation?.recommendation;
  const enabled = recommendation?.id && !loading ? true : false;

  const { risk, isLoading: isRiskMatrixLoading } =
    useGetObservationRiskMatrix(observation);

  const displayLoading = enabled ? loading || isRiskMatrixLoading : false;

  return (
    <InterventionAddButton
      ancestors={interventionAsset?.ancestors}
      max_days_delay={risk?.due_days}
      recommendation={recommendation ?? undefined}
      redirectToModel={false}
      disabled={!enabled}
      loading={displayLoading}
      style={{ marginBottom: 10 }}
      {...buttonprops}
    />
  );
};

export default RecommendationAddInterventionButton;
